import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { Button, Tooltip } from '@mui/material'
import pvtgif from '../../assets/pvt/pvt-web.gif'
import { Indicator } from '../../components'
import { timestampToDDMMHHMM } from '../../utils/dateConversion'
import useViewport from '../../hooks/useViewport'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 24px 44px;
`

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IndicatorContainer = styled.div`
  display: flex;
  gap: 8px;
  ${({ width }) =>
    width <= 900 &&
    css`
      max-width: 600px;
      overflow: scroll;
    `}
`

const IndicatorItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 220px;
  max-width: 265px;

  > span {
    margin-top: 8px;
  }
`

const GifContainer = styled.div`
  margin: 8px 0;
`

const PVTInstructions = ({ status, blockedUntil, duration, onStart }) => {
  const [disableStart, setDisableStart] = useState(true)
  const { width, height } = useViewport()
  const { t } = useTranslation('common')

  const listInfo = [
    t('pvt.instructions.list.one'),
    t('pvt.instructions.list.two'),
    t('pvt.instructions.list.three'),
    t('pvt.instructions.list.four'),
  ]

  useEffect(() => {
    if (status !== 'blocked' && blockedUntil <= Date.now()) {
      setDisableStart(false)
    }
  }, [status, blockedUntil])

  return (
    <Container>
      <HeaderContainer>
        <span style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
          {t('pvt.instructions.header')}
        </span>
        <span>
          {t('pvt.instructions.duration', { duration: duration })}
          {duration === 1 ? t('pvt.instructions.minute') : t('pvt.instructions.plural_min')}.
        </span>
      </HeaderContainer>

      <GifContainer>
        <img
          src={pvtgif}
          height={height * 0.35}
          width='100%'
        />
      </GifContainer>

      <IndicatorContainer width={width}>
        {listInfo.map((item, index) => (
          <IndicatorItemContainer key={index}>
            <Indicator number={index + 1} />
            <span>{item}</span>
          </IndicatorItemContainer>
        ))}
      </IndicatorContainer>

      {disableStart ? (
        <Tooltip
          title={t('pvt.instructions.disabled', { blocked_until: timestampToDDMMHHMM({ timestamp: blockedUntil })})}
          arrow
        >
          <span></span>
          <Button
            variant='contained'
            disabled
          >
            {t('pvt.begin')}
          </Button>
        </Tooltip>
      ) : (
        <Button
          variant='contained'
          onClick={onStart}
        >
          {t('pvt.begin')}
        </Button>
      )}
    </Container>
  )
}

export default PVTInstructions
